/**
 * CTA reconstruction effect — fires ONCE when the prefooter CTA's
 * decorative halo enters the viewport. Adds `is-reconstructing` to
 * the vector wrapper, which triggers a CSS keyframe cascade across
 * the 9 stacked layers (back→front, 110ms stagger), assembling the
 * halo from depth into focus.
 *
 * The CSS keeps layers at opacity:0 by default so they're invisible
 * before the trigger fires. We disconnect the observer after the
 * first intersection so the animation never replays — this is a
 * one-shot reveal, not a loop.
 *
 * Honors `prefers-reduced-motion`: in that case CSS shows all layers
 * immediately and we never wire up the observer.
 */
const wrapper = document.querySelector('[data-cta-reconstruct]');
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (wrapper && !prefersReduced) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          wrapper.classList.add('is-reconstructing');
          observer.disconnect();
        }
      });
    },
    {
      // Fire on FIRST intersection (any pixel). The halo bleeds mostly
      // below the CTA section (bottom:-688), so on mobile its on-screen
      // area peaks at only ~17% — the old 0.15 threshold was never
      // reliably reached and the fade-rise entrance silently never fired.
      // threshold:0 fires the moment the halo's top edge scrolls into
      // view, which is exactly when the reveal should begin — robust no
      // matter how little of the (mostly-below-fold) halo is on-screen.
      threshold: 0,
    },
  );
  observer.observe(wrapper);
} else if (wrapper && prefersReduced) {
  // Reduced-motion users: skip the animation entirely, just show it.
  wrapper.classList.add('is-reconstructing');
}
